import {
  MDBCollapse,
  MDBIcon,
  MDBNavbar,
  MDBNavbarNav,
  MDBNavItem,
  MDBNavLink,
} from "mdbreact";
import Swal from "sweetalert2";
import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { Images } from "../../Assets/Images";
import { userContext } from "../../Context/user";
import { auth, db } from "../../fire";
import { Routes } from "../../Routes";
import styles from "./index.module.css";
import {
  MDBDropdown,
  MDBDropdownToggle,
  MDBDropdownMenu,
  MDBDropdownItem,
} from "mdbreact";

class Layout extends Component {
  state = {
    closed: false,
    authorizationType: "",
    availableMatters: [],
    hasPendingService: false,
    checkingPermissions: true,
  };

  pagesToHideSidebar = [Routes.MATERIA, Routes.EDITOR];

  componentDidMount() {
    const { pathname } = this.props.history.location;
    const { user } = this.context;

    const { autorizacoes } = user.prestadorDeServico;
    const autorizacao = autorizacoes[0];

    this.setState({
      authorizationType: autorizacao.tipoDeServico,
      availableMatters: autorizacao.nomesMaterias,
    });

    this.checkIfShouldHideSidebar(pathname);
    this.checkIfuserHasPendingService(pathname);

    this.props.history.listen(({ pathname }) => {
      this.checkIfShouldHideSidebar(pathname);
    });
  }

  checkIfShouldHideSidebar = (pathname) => {
    const index = this.pagesToHideSidebar.findIndex((page) =>
      pathname.startsWith(page)
    );

    this.setState({ closed: index >= 0 });
  };

  checkIfRoutesMatch = (route) => {
    const { pathname } = this.props.history.location;
    const itsAMatch = pathname.slice(1).startsWith(route.slice(1));

    return itsAMatch;
  };

  doLogout = async () => {
    await auth.signOut();
    window.location.href = "/";
  };

  checkIfuserHasPendingService = async () => {
    try {
      const { user } = this.context;

      let serviceRef;

      serviceRef = await db
        .collection("pedidosDeServico")
        .where("status", "==", "Atribuido")
        .where("prestadorID", "==", user.id)
        .limit(1)
        .get();

      if (serviceRef.empty) return;

      this.setState({
        hasPendingService: true,
        service: {
          id: serviceRef.docs[0].id,
          ...serviceRef.docs[0].data(),
        },
      });
    } catch (error) {
      console.error(error);
    } finally {
      this.setState({
        checkingPermissions: false,
      });
    }
  };

  redirectToService = async () => {
    try {
      const { service, authorizationType } = this.state;

      Swal.fire({
        title: "Buscando Dados...",
        text:
          "Buscando as informações do pedido de serviço, por favor aguarde.",
        icon: "info",
        allowEscapeKey: false,
        allowEnterKey: false,
        showCancelButton: false,
        showConfirmButton: false,
        allowOutsideClick: false,
      });

      const objetoRef = await service.objetoRef.get();
      const objetoResultadoRef = await service.objetoResultadoRef.get();

      const serviceData = {
        ...service,
        objetoRef: objetoRef.data(),
        objetoResultadoRef: objetoResultadoRef.data(),
      };

      this.props.history.push(Routes.EDITOR, {
        service: serviceData,
        authorizationType,
        user: this.context?.user,
      });
    } catch (error) {
      console.log({ error });

      await Swal.fire({
        title: "Falha ao encontrar informações!",
        text: "Por favor, entre em contato com o suporte",
        icon: "error",
      });
    } finally {
      Swal.close();
    }
  };

  checkBeforeRedirect = async () => {
    if (this.props.location.pathname === Routes.EDITOR) {
      const result = await Swal.fire({
        title: "Você está prestes a sair dessa tela!",
        html:
          "Ao sair dessa tela por aqui, <b>todo conteudo não salvo será perdido</b>, tem certeza que deseja continuar?",
        icon: "warning",
        confirmButtonText: "Sair sem salvar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
      });

      if (result.dismiss) return;
    }

    this.props.history.push(Routes.HOME);
  };

  render() {
    const {
      closed,
      availableMatters,
      authorizationType,
      hasPendingService,
    } = this.state;
    const { pathname } = this.props.history.location;
    const { user } = this.context;
    const { autorizacoes } = user.prestadorDeServico;

    return (
      <div className={styles.container}>
        <div className={styles.header}>
          <div className="d-flex flex-column">
            <div
              style={{ cursor: "pointer" }}
              onClick={this.checkBeforeRedirect}
              className="p-3 ml-3"
            >
              <img src={Images.logo} alt="" className={styles.logo} />
            </div>
          </div>
          <div className="d-flex flex-column">
            <div className={styles["user-info"]}>
              <img src={user.avatar || Images.avatar} alt={user.primeiroNome} />
              {user.primeiroNome + " " + user.sobrenome}
            </div>
            {(this.checkIfRoutesMatch(Routes.HOME) || pathname === "/") &&
              Array.isArray(autorizacoes) && (
                <MDBDropdown>
                  <MDBDropdownToggle
                    disabled={hasPendingService}
                    nav
                    caret
                    color="black"
                  >
                    {this.state.authorizationType}
                  </MDBDropdownToggle>
                  <MDBDropdownMenu color="blue">
                    <MDBDropdownItem disabled>
                      Autorização ativa
                    </MDBDropdownItem>
                    {autorizacoes.map((autorizacao) => {
                      return (
                        <MDBDropdownItem
                          key={autorizacao.tipoDeServico}
                          active={
                            this.state.authorizationType ===
                            autorizacao.tipoDeServico
                          }
                          onClick={() => {
                            this.setState({
                              authorizationType: autorizacao.tipoDeServico,
                              availableMatters: autorizacao.nomesMaterias,
                            });
                          }}
                        >
                          {autorizacao.tipoDeServico}
                        </MDBDropdownItem>
                      );
                    })}
                  </MDBDropdownMenu>
                </MDBDropdown>
              )}
          </div>
        </div>
        <div className="d-flex">
          <div className="d-flex flex-column">
            <div
              className={`${styles.sidebar} ${
                closed ? styles["sidebar--closed"] : ""
              }`}
            >
              <MDBNavbar
                style={{ marginTop: "20px" }}
                light
                className={styles.nav}
              >
                <MDBNavbarNav left>
                  <MDBNavItem
                    active={this.checkIfRoutesMatch(Routes.HOME)}
                    className="mb-2"
                  >
                    <MDBNavLink
                      onClick={() => {
                        if (hasPendingService) {
                          this.redirectToService();
                        } else {
                          this.setState({
                            openAccordion: !this.state.openAccordion,
                          });
                        }
                      }}
                      to={Routes.HOME}
                    >
                      <MDBIcon icon="graduation-cap" className="pl-2 mr-2" />
                      MATÉRIAS
                    </MDBNavLink>
                  </MDBNavItem>
                  <MDBCollapse
                    id="collapse2"
                    isOpen={this.state.openAccordion}
                    className="pl-0"
                  >
                    {Array.isArray(availableMatters) &&
                      !hasPendingService &&
                      availableMatters.map((matter) => {
                        return (
                          <button
                            className={styles["acces-button"]}
                            key={matter}
                            onClick={() => {
                              this.props.history.push(
                                `${Routes.MATERIA}/${matter}`,
                                { authorizationType, subject: matter }
                              );
                            }}
                          >
                            ><div className="pl-2">{matter}</div>
                          </button>
                        );
                      })}
                  </MDBCollapse>
                  <MDBNavItem
                    active={this.checkIfRoutesMatch(Routes.PRODUCAO)}
                    className="mb-2 mt-2"
                  >
                    <MDBNavLink to={Routes.PRODUCAO}>
                      <MDBIcon icon="heart" className="pl-2 mr-2" />
                      PRODUÇÃO
                    </MDBNavLink>
                  </MDBNavItem>
                  <MDBNavItem
                    active={this.checkIfRoutesMatch(Routes.ARTIGOS)}
                    className="mb-2 mt-2"
                  >
                    <MDBNavLink to={Routes.ARTIGOS}>
                      <MDBIcon icon="file-alt" className="pl-2 mr-2" />
                      ARTIGOS
                    </MDBNavLink>
                  </MDBNavItem>
                  <MDBNavItem
                    active={this.checkIfRoutesMatch(Routes.PERFIL)}
                    className="mb-2 mt-2"
                  >
                    <MDBNavLink to={Routes.PERFIL}>
                      <MDBIcon icon="user-alt" className="pl-2 mr-2" />
                      PERFIL
                    </MDBNavLink>
                  </MDBNavItem>
                  <MDBNavItem onClick={this.doLogout} className="mb-2 mt-2">
                    <MDBNavLink to="#!">
                      <MDBIcon icon="times" className="pl-2 mr-2" />
                      SAIR
                    </MDBNavLink>
                  </MDBNavItem>
                </MDBNavbarNav>
              </MDBNavbar>
            </div>
          </div>
          <div className="flex-1">{this.props.children}</div>
        </div>
      </div>
    );
  }
}

Layout.contextType = userContext;

export default withRouter(Layout);
